/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_Body_1Inputs */

const en_wb_sales_body_1 = /** @type {(inputs: Wb_Sales_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hi Alex,`)
};

const lv_wb_sales_body_1 = /** @type {(inputs: Wb_Sales_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sveiki, Alex!`)
};

/**
* | output |
* | --- |
* | "Hi Alex," |
*
* @param {Wb_Sales_Body_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_body_1 = /** @type {((inputs?: Wb_Sales_Body_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_Body_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_body_1(inputs)
	return en_wb_sales_body_1(inputs)
});